<template>
    <Dialog
      :visible="props.visible"
      class="dialog"
      :closable="true"
      :modal="true"
      :aria-label="'Loading progress modal'"
      :aria-expanded="props.visible"
      :close-on-escape="true"
    >
      <div class="wrapper" v-focustrap aria-modal="true">
        <div
          class="title"
        >
          Hang tight!
        </div>
        <div class="content">
          <p>Your recording is uploading.</p>
          <p>Keep the app open for a moment.</p>
          <ProgressBar
              class="progress-bar"
              :value="props.progress"
              :showValue="false"
              v-if="props.loading"
          />
        </div>
    </div>
    </Dialog>
  </template>
  
  <script setup>
  
  const props = defineProps({
    visible: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true
    },
    progress: {
      type: Number,
      required: true
    }
  });
  </script>
  
  <style lang="scss">
  .dialog {
    border-radius: 1.4rem;

    .p-dialog-header {
      display: none;
    }
    
    .p-dialog-content {
      background-color: map-get($colours, accent-purple-2);
      width: 46rem;
      border-radius: 1.4rem;
      margin: 0;
      padding: 0;
    }
  
    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: white;
      width: 46rem;
      margin: 0;
      padding: 4rem;
      background-color: map-get($colours, accent-purple-2);
      font-family: $font-secondary;
  
      .title {
        font-family: $font-accent;
        margin: 0;
        padding: 0;
        margin-bottom: 1rem;
      }

      .content {
        width: 100%;
        padding: 2.4rem;
      }
    }
  }

.progress-bar {
  width: 100%;
  height: 0.6rem;
  padding: 0;
  margin: 48px auto 0 auto;
}
.p-progressbar {
  background-color: map-get($colours, accent-purple-3);
  border-radius: 0.6rem;
}

.p-progressbar .p-progressbar-value {
  padding: 0;
  background-color: map-get($colours, green);
}
  </style>
  